import { EnrollmentData } from './enrollment-data'
import { EnrollmentField } from './enrollment-field'
import { EnrollmentViewModel } from './enrollment-view-model'
import { EnrollmentFieldCodeName } from './enrollment-name-enum'
import * as moment from 'moment'
import { PortalGlobals } from '../../portalglobals'
import { RaceEthnicityComponent } from '../components/common/race-ethnicity.component'

export class SetEnrollmentDataPdf {
    private portalGlob: PortalGlobals
    private _raceEthnicityComponent: RaceEthnicityComponent
    setEnrollmentDataPDF(enrollmentViewModel: EnrollmentViewModel, insCompanyName: string): EnrollmentData {
        this.portalGlob = new PortalGlobals()
        var enrollmentData = {} as EnrollmentData
        enrollmentData.EnrollmentFields = [] as EnrollmentField[]
        // enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.AGENTEMAIL, FieldValue: enrollmentViewModel.AGENTEMAIL })
        enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.CONF, FieldValue: enrollmentViewModel.CONF })
        enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.AGENTID, FieldValue: enrollmentViewModel.AGENTNAME })
        enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.DATAENTRYID, FieldValue: enrollmentViewModel.USERNAME })
        enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.TITLE, FieldValue: enrollmentViewModel.TITLE })
        enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.APPFN, FieldValue: enrollmentViewModel.APPFN })
        enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.APPMI, FieldValue: enrollmentViewModel.APPMI })
        enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.APPLN, FieldValue: enrollmentViewModel.APPLN })

        enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.HICN, FieldValue: enrollmentViewModel.HICN })
        enrollmentData.EnrollmentFields.push({
            FieldCode: EnrollmentFieldCodeName.APPDT,
            FieldValue:
                enrollmentViewModel.APPDT === undefined || enrollmentViewModel.APPDT === null
                    ? ''
                    : moment(enrollmentViewModel.APPDT).format('MM/DD/YYYY')
        })
        enrollmentData.EnrollmentFields.push({
            FieldCode: EnrollmentFieldCodeName.EFFDT,
            FieldValue:
                enrollmentViewModel.EFFDT === undefined || enrollmentViewModel.EFFDT === null
                    ? ''
                    : moment(enrollmentViewModel.EFFDT).format('MM/DD/YYYY')
        })
        enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.APPST, FieldValue: enrollmentViewModel.APPST })
        enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.PLANNAME, FieldValue: enrollmentViewModel.PLANTYPENAME })
        enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.CUID, FieldValue: enrollmentViewModel.CUID })
        enrollmentData.EnrollmentFields.push({
            FieldCode: EnrollmentFieldCodeName.SEPEFFDT,
            FieldValue:
                enrollmentViewModel.SEPEFFDT === undefined || enrollmentViewModel.SEPEFFDT === null
                    ? ''
                    : moment(enrollmentViewModel.SEPEFFDT).format('MM/DD/YYYY')
        })
        enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.ELECTION, FieldValue: enrollmentViewModel.ELECTION })
        enrollmentData.EnrollmentFields.push({
            FieldCode: EnrollmentFieldCodeName.SEPREASONCD,
            FieldValue:
                enrollmentViewModel.SEPREASONCD === undefined
                    ? ''
                    : enrollmentViewModel.SEPREASONCD.toString() + ' - ' + enrollmentViewModel.SEPREASONTEXT.toString()
        })
        enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.AGENTDEX, FieldValue: enrollmentViewModel.AGENTDEX })
        enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.APPPHONE, FieldValue: enrollmentViewModel.APPPHONE })
        enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.CELLPHONE, FieldValue: enrollmentViewModel.CELLPHONE })
        enrollmentData.EnrollmentFields.push({
            FieldCode: EnrollmentFieldCodeName.APPDOB,
            FieldValue:
                enrollmentViewModel.APPDOB === undefined || enrollmentViewModel.APPDOB === null
                    ? ''
                    : moment(enrollmentViewModel.APPDOB).format('MM/DD/YYYY')
        })

        enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.APPGEN, FieldValue: enrollmentViewModel.APPGEN === 'M' ? 'Male' : 'Female' })
        enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.APPEMAIL, FieldValue: enrollmentViewModel.APPEMAIL })
        enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.APPADD1, FieldValue: enrollmentViewModel.APPADD1 })
        enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.APPADD2, FieldValue: enrollmentViewModel.APPADD2 })
        enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.APPCITY, FieldValue: enrollmentViewModel.APPCITY })
        enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.PERST, FieldValue: enrollmentViewModel.APPST })
        enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.APPZIP, FieldValue: enrollmentViewModel.APPZIP })
     
            if (Number(enrollmentViewModel.PLANYEAR) > this.portalGlob.Planyear2025) {
               
                enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.POVERIND, FieldValue: enrollmentViewModel.POVERIND === '1' ? 'Yes' : 'No' })
            }
        
        enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.MAILADD1, FieldValue: enrollmentViewModel.MAILADD1 })
        enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.MAILADD2, FieldValue: enrollmentViewModel.MAILADD2 })
        enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.MAILCITY, FieldValue: enrollmentViewModel.MAILCITY })
        enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.MAILST, FieldValue: enrollmentViewModel.MAILST })
        enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.MAILZIP, FieldValue: enrollmentViewModel.MAILZIP })
        enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.LTCFACILITY, FieldValue: enrollmentViewModel.LTCFACILITY })
        enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.LTCPHONE, FieldValue: enrollmentViewModel.LTCPHONE })
        if (enrollmentViewModel.LTCADD1 !== undefined && enrollmentViewModel.LTCADD1 !== '') {
            enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.LTCADD1, FieldValue: enrollmentViewModel.LTCADD1 })
        }

        enrollmentData.EnrollmentFields.push({
            FieldCode: EnrollmentFieldCodeName.MEDA,
            FieldValue:
                enrollmentViewModel.MEDA === undefined || enrollmentViewModel.MEDA === null
                    ? ''
                    : moment(enrollmentViewModel.MEDA).format('MM/DD/YYYY')
        })
        enrollmentData.EnrollmentFields.push({
            FieldCode: EnrollmentFieldCodeName.MEDB,
            FieldValue:
                enrollmentViewModel.MEDB === undefined || enrollmentViewModel.MEDB === null
                    ? ''
                    : moment(enrollmentViewModel.MEDB).format('MM/DD/YYYY')
        })
        enrollmentData.EnrollmentFields.push({
            FieldCode: EnrollmentFieldCodeName.PREMIUMPAYTYPE,
            FieldValue: enrollmentViewModel.PWO === undefined ? '' : enrollmentViewModel.PWO
        }) //to check

        enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.LANG, FieldValue: enrollmentViewModel.LANG })
        //if (!enrollmentViewModel.ISSINGLEGROUP) {
        let eobValue = ''
        let paperlessValue = ''
        let accessibleValue = ''
        if (enrollmentViewModel.EOB !== undefined && enrollmentViewModel.EOB !== null) {
            if (enrollmentViewModel.EOB === '3') {
                paperlessValue = 'Yes'
            } else if (enrollmentViewModel.EOB.toString().toUpperCase() === 'N') {
                paperlessValue = 'No'
            }

            if (enrollmentViewModel.ISSINGLEGROUP) {
                eobValue = ''
            } else if (
                enrollmentViewModel.EOB.toString().toUpperCase() === 'EEOB' ||
                enrollmentViewModel.EOB === '5' ||
                enrollmentViewModel.EOB === '6' ||
                enrollmentViewModel.EOB === '7' ||
                enrollmentViewModel.EOB === '9'
            ) {
                eobValue = 'Yes'
            } else if (
                enrollmentViewModel.EOB.toString().toUpperCase() === 'PEOB' ||
                enrollmentViewModel.EOB === '1' ||
                enrollmentViewModel.EOB === '2' ||
                enrollmentViewModel.EOB === '4' ||
                enrollmentViewModel.EOB === '8'
            ) {
                eobValue = 'No'
            }

            if (enrollmentViewModel.EOB === '1' || enrollmentViewModel.EOB === '5') {
                accessibleValue = 'Large Print'
            } else if (enrollmentViewModel.EOB === '2' || enrollmentViewModel.EOB === '6') {
                accessibleValue = 'Braille'
            } else if (enrollmentViewModel.EOB === '4' || enrollmentViewModel.EOB === '7') {
                accessibleValue = 'Audio CD'
            } else if (enrollmentViewModel.EOB === '8' || enrollmentViewModel.EOB === '9') {
                accessibleValue = 'Data CD'
            } else {
                accessibleValue = ''
            }
        } else {
            enrollmentViewModel.EOB = ''
        }

        //For print and PDF after enrollment finished
        //if (enrollmentViewModel.PaperlessSettings !== undefined && enrollmentViewModel.PaperlessSettings !== null) {
        //    if (enrollmentViewModel.PaperlessSettings === true) {
        //        enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.PaplerlessEOB, FieldValue: paperlessValue })
        //    }
        //    else {
        if (insCompanyName !== '' && insCompanyName !== undefined && insCompanyName !== null) {
            if (insCompanyName !== this.portalGlob.insuranceCompanyNameNEJE) {
                enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.PaplerlessEOB, FieldValue: eobValue })
            }
        }

        //}
        if (
            insCompanyName !== '' &&
            insCompanyName !== undefined &&
            insCompanyName !== null &&
            insCompanyName == this.portalGlob.insuranceCompanyNameNEJE &&
            enrollmentViewModel.PLANYEAR === '2023'
        ) {
            // Accessible not required
            // enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.Accessible, FieldValue: accessibleValue })
        } else {
            enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.Accessible, FieldValue: accessibleValue })
        }

        //    }
        //}
        //else
        //    enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.PaplerlessEOB, FieldValue: paperlessValue })

        //}
        if (insCompanyName !== '' && insCompanyName !== undefined && insCompanyName !== null) {
            if (insCompanyName == this.portalGlob.insuranceCompanyNameNEJE && enrollmentViewModel.PLANYEAR === '2021') {
                enrollmentData.EnrollmentFields.push({
                    FieldCode: EnrollmentFieldCodeName.ENROLLEEWORKSTATUS,
                    FieldValue: enrollmentViewModel.ENROLLEEWORKSTATUS
                })
                enrollmentData.EnrollmentFields.push({
                    FieldCode: EnrollmentFieldCodeName.SPOUSEWORKSTATUS,
                    FieldValue: enrollmentViewModel.SPOUSEWORKSTATUS
                })
            }
        }

        if (enrollmentViewModel.ISSTCOB !== undefined) {
            if (!enrollmentViewModel.ISSTCOB) {
                enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.PCARRIER, FieldValue: enrollmentViewModel.CARRIER })
                enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.PACCOUNT, FieldValue: enrollmentViewModel.ACCOUNT })
                enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.PGROUP, FieldValue: enrollmentViewModel.GROUP })
            } else {
                // if (insCompanyName == this.portalGlob.insuranceCompanyNameNEJE) {
                enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.SCARRIER, FieldValue: enrollmentViewModel.CARRIER })
                enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.SACCOUNT, FieldValue: enrollmentViewModel.ACCOUNT })
                enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.SGROUP, FieldValue: enrollmentViewModel.GROUP })
                /*
            }
            else {
                enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.SCARRIER, FieldValue: enrollmentViewModel.SECCARRIER })
                enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.SACCOUNT, FieldValue: enrollmentViewModel.SECACCOUNT })
                enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.SGROUP, FieldValue: enrollmentViewModel.SECGROUP })
            }
            */
                enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.SECMBRID, FieldValue: enrollmentViewModel.SECMBRID })
                enrollmentData.EnrollmentFields.push({
                    FieldCode: EnrollmentFieldCodeName.RELCD,
                    FieldValue: enrollmentViewModel.RELCD + '-' + enrollmentViewModel.RELTEXT
                })
                enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.FAMILYID, FieldValue: enrollmentViewModel.FAMILYID })
                enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.PERSONCD, FieldValue: enrollmentViewModel.PERSONCD })
            }
        }

        enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.CAREQUALIFIER, FieldValue: enrollmentViewModel.CAREQUAL })
        if (enrollmentViewModel.ISSINGLEGROUP) {
            enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.CAREFACILITY, FieldValue: enrollmentViewModel.CAREFAC }) //to check
            enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.EXTERNALMEMBERID, FieldValue: enrollmentViewModel.EXTERNALID }) //to check
        }
        enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.OTHERCOVNAME, FieldValue: enrollmentViewModel.OTHCVRGNAME })
        enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.OTHCVRGID, FieldValue: enrollmentViewModel.OTHCVRGID })
        enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.OTHERCOVGRP, FieldValue: enrollmentViewModel.OTHCVRGGRP })
        enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.OTHERCOVRXBIN, FieldValue: enrollmentViewModel.COBBIN })
        enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.OTHERCOVRXPCN, FieldValue: enrollmentViewModel.COBPCN })
        enrollmentData.EnrollmentFields.push({
            FieldCode: EnrollmentFieldCodeName.OTHERCOVEF,
            FieldValue:
                enrollmentViewModel.COBEFFDT === undefined || enrollmentViewModel.COBEFFDT === null
                    ? ''
                    : moment(enrollmentViewModel.COBEFFDT).format('MM/DD/YYYY')
        })
        enrollmentData.EnrollmentFields.push({
            FieldCode: EnrollmentFieldCodeName.OTHERCOVTR,
            FieldValue:
                enrollmentViewModel.COBTERMDT === undefined || enrollmentViewModel.COBTERMDT === null
                    ? ''
                    : moment(enrollmentViewModel.COBTERMDT).format('MM/DD/YYYY')
        })

        enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.AUTHREPNAME, FieldValue: enrollmentViewModel.AUTHREPNAME })
        enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.AUTHREPPHONE, FieldValue: enrollmentViewModel.AUTHREPPHONE })
        enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.AUTHREPREL, FieldValue: enrollmentViewModel.AUTHREPREL })
        enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.AUTHREPADD1, FieldValue: enrollmentViewModel.AUTHREPADD1 })
        enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.AUTHREPADD2, FieldValue: enrollmentViewModel.AUTHREPADD2 })
        enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.AUTHREPCITY, FieldValue: enrollmentViewModel.AUTHREPCITY })
        enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.AUTHREPST, FieldValue: enrollmentViewModel.AUTHREPST })
        enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.AUTHREPZIP, FieldValue: enrollmentViewModel.AUTHREPZIP })

        if (Number(enrollmentViewModel.PLANYEAR) > this.portalGlob.Planyear2024) {
            // enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.INDREPIND, FieldValue: enrollmentViewModel.INDREPIND })
            enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.INDREPNAME, FieldValue: enrollmentViewModel.INDREPNAME })
            enrollmentData.EnrollmentFields.push({
                FieldCode: EnrollmentFieldCodeName.RELTOENROLL,
                FieldValue: enrollmentViewModel.displayRELTOENROLL
            })
            enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.NPN, FieldValue: enrollmentViewModel.NPN })
        }

        enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.ACCHOLDERNAME, FieldValue: enrollmentViewModel.ACCHOLDERNAME })
        enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.ACCOUNTTYPE, FieldValue: enrollmentViewModel.EFTTYPE || '' })
        enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.ROUTINGNB, FieldValue: enrollmentViewModel.ROUTINGNB })
        enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.FININSTNAME, FieldValue: enrollmentViewModel.FININSTNAME })
        enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.ACCOUNTNB, FieldValue: enrollmentViewModel.ACCOUNTNB })
        enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.NOTES, FieldValue: enrollmentViewModel.NOTES })
        if (insCompanyName !== '' && insCompanyName !== undefined && insCompanyName !== null) {
            if (insCompanyName !== this.portalGlob.insuranceCompanyNameNEJE) {
                enrollmentData.EnrollmentFields.push({
                    FieldCode: EnrollmentFieldCodeName.DISENROLLIND,
                    FieldValue: enrollmentViewModel.DISENROLLIND
                })
                enrollmentData.EnrollmentFields.push({
                    FieldCode: EnrollmentFieldCodeName.DISENROLLDATE,
                    FieldValue:
                        enrollmentViewModel.DISENROLLDATE === undefined ||
                        enrollmentViewModel.DISENROLLDATE === null ||
                        enrollmentViewModel.DISENROLLDATE === ''
                            ? ''
                            : moment(enrollmentViewModel.DISENROLLDATE).format('MM/DD/YYYY')
                })
                enrollmentData.EnrollmentFields.push({
                    FieldCode: EnrollmentFieldCodeName.DISENROLLNOTICEDT,
                    FieldValue:
                        enrollmentViewModel.DISENROLLNOTICEDT === undefined ||
                        enrollmentViewModel.DISENROLLNOTICEDT === null ||
                        enrollmentViewModel.DISENROLLNOTICEDT === ''
                            ? ''
                            : moment(enrollmentViewModel.DISENROLLNOTICEDT).format('MM/DD/YYYY')
                })
                enrollmentData.EnrollmentFields.push({
                    FieldCode: EnrollmentFieldCodeName.DISENROLLREASONCD,
                    FieldValue: enrollmentViewModel.DISENROLLREASONCD
                })
                enrollmentData.EnrollmentFields.push({
                    FieldCode: EnrollmentFieldCodeName.DISENROLLTYPE,
                    FieldValue: enrollmentViewModel.DISENROLLTYPE
                })
            }
        } else {
            enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.DISENROLLIND, FieldValue: enrollmentViewModel.DISENROLLIND })
            enrollmentData.EnrollmentFields.push({
                FieldCode: EnrollmentFieldCodeName.DISENROLLDATE,
                FieldValue:
                    enrollmentViewModel.DISENROLLDATE === undefined ||
                    enrollmentViewModel.DISENROLLDATE === null ||
                    enrollmentViewModel.DISENROLLDATE === ''
                        ? ''
                        : moment(enrollmentViewModel.DISENROLLDATE).format('MM/DD/YYYY')
            })
            enrollmentData.EnrollmentFields.push({
                FieldCode: EnrollmentFieldCodeName.DISENROLLNOTICEDT,
                FieldValue:
                    enrollmentViewModel.DISENROLLNOTICEDT === undefined ||
                    enrollmentViewModel.DISENROLLNOTICEDT === null ||
                    enrollmentViewModel.DISENROLLNOTICEDT === ''
                        ? ''
                        : moment(enrollmentViewModel.DISENROLLNOTICEDT).format('MM/DD/YYYY')
            })
            enrollmentData.EnrollmentFields.push({
                FieldCode: EnrollmentFieldCodeName.DISENROLLREASONCD,
                FieldValue: enrollmentViewModel.DISENROLLREASONCD
            })
            enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.DISENROLLTYPE, FieldValue: enrollmentViewModel.DISENROLLTYPE })
        }
        if (Number(enrollmentViewModel.PLANYEAR) < this.portalGlob.Planyear2026) {
            enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.ETHNICITY, FieldValue: enrollmentViewModel.displayEthnicity })
            enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.RACE, FieldValue: enrollmentViewModel.displayRace })
        }
        /*
        if (Number(enrollmentViewModel.PLANYEAR) > this.portalGlob.Planyear2024) {
            enrollmentData.EnrollmentFields.push({
                FieldCode: EnrollmentFieldCodeName.CURRENTGENDER,
                FieldValue: enrollmentViewModel.displayCurrentGender
            })
            enrollmentData.EnrollmentFields.push({
                FieldCode: EnrollmentFieldCodeName.CURRENTGENDEROTH,
                FieldValue: enrollmentViewModel.CURRENTGENDEROTH
            })
            enrollmentData.EnrollmentFields.push({
                FieldCode: EnrollmentFieldCodeName.GENDERNPRONOUN,
                FieldValue: enrollmentViewModel.displayGenderProNoun
            })
            enrollmentData.EnrollmentFields.push({
                FieldCode: EnrollmentFieldCodeName.GENDERNPRONOUNOTH,
                FieldValue: enrollmentViewModel.GENDERNPRONOUNOTH
            })
        }
        */

        return enrollmentData
    }

    setEnrollmentDataPDFSearch(enrollmentViewModel: EnrollmentViewModel, insCompanyName: string): EnrollmentData {
        this.portalGlob = new PortalGlobals()

        var enrollmentData = {} as EnrollmentData
        enrollmentData.EnrollmentFields = [] as EnrollmentField[]
        // enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.AGENTEMAIL, FieldValue: enrollmentViewModel.AGENTEMAIL })
        enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.CONF, FieldValue: enrollmentViewModel.CONF })
        enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.AGENTID, FieldValue: enrollmentViewModel.AGENTNAME })
        enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.DATAENTRYID, FieldValue: enrollmentViewModel.USERNAME })
        enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.TITLE, FieldValue: enrollmentViewModel.TITLE })
        enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.APPFN, FieldValue: enrollmentViewModel.APPFN })
        enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.APPMI, FieldValue: enrollmentViewModel.APPMI })
        enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.APPLN, FieldValue: enrollmentViewModel.APPLN })

        enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.HICN, FieldValue: enrollmentViewModel.HICN })
        enrollmentData.EnrollmentFields.push({
            FieldCode: EnrollmentFieldCodeName.APPDT,
            FieldValue:
                enrollmentViewModel.APPDT === undefined || enrollmentViewModel.APPDT === null
                    ? ''
                    : moment(enrollmentViewModel.APPDT).format('MM/DD/YYYY')
        })
        enrollmentData.EnrollmentFields.push({
            FieldCode: EnrollmentFieldCodeName.EFFDT,
            FieldValue:
                enrollmentViewModel.EFFDT === undefined || enrollmentViewModel.EFFDT === null
                    ? ''
                    : moment(enrollmentViewModel.EFFDT).format('MM/DD/YYYY')
        })
        enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.APPST, FieldValue: enrollmentViewModel.APPST })
        enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.PLANNAME, FieldValue: enrollmentViewModel.PLANTYPENAME })
        enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.CUID, FieldValue: enrollmentViewModel.CUID })
        enrollmentData.EnrollmentFields.push({
            FieldCode: EnrollmentFieldCodeName.SEPEFFDT,
            FieldValue:
                enrollmentViewModel.SEPEFFDT === undefined || enrollmentViewModel.SEPEFFDT === null
                    ? ''
                    : moment(enrollmentViewModel.SEPEFFDT).format('MM/DD/YYYY')
        })
        enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.ELECTION, FieldValue: enrollmentViewModel.ELECTION })
        enrollmentData.EnrollmentFields.push({
            FieldCode: EnrollmentFieldCodeName.SEPREASONCD,
            FieldValue:
                enrollmentViewModel.SEPREASONCD === undefined
                    ? ''
                    : enrollmentViewModel.SEPREASONCD.toString() + ' - ' + enrollmentViewModel.SEPREASONTEXT.toString()
        })
        enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.AGENTDEX, FieldValue: enrollmentViewModel.AGENTDEX })
        enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.APPPHONE, FieldValue: enrollmentViewModel.APPPHONE })
        enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.CELLPHONE, FieldValue: enrollmentViewModel.CELLPHONE })
        enrollmentData.EnrollmentFields.push({
            FieldCode: EnrollmentFieldCodeName.APPDOB,
            FieldValue:
                enrollmentViewModel.APPDOB === undefined || enrollmentViewModel.APPDOB === null
                    ? ''
                    : moment(enrollmentViewModel.APPDOB).format('MM/DD/YYYY')
        })
        enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.APPGEN, FieldValue: enrollmentViewModel.APPGEN === 'M' ? 'Male' : 'Female' })
       // enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.APPGEN, FieldValue: enrollmentViewModel.APPGEN })
        enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.APPEMAIL, FieldValue: enrollmentViewModel.APPEMAIL })
        enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.APPADD1, FieldValue: enrollmentViewModel.APPADD1 })
        enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.APPADD2, FieldValue: enrollmentViewModel.APPADD2 })
        enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.APPCITY, FieldValue: enrollmentViewModel.APPCITY })
        enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.PERST, FieldValue: enrollmentViewModel.APPST })
        enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.APPZIP, FieldValue: enrollmentViewModel.APPZIP })
        
            if (Number(enrollmentViewModel.PLANYEAR) > this.portalGlob.Planyear2025) {

                enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.POVERIND, FieldValue: enrollmentViewModel.POVERIND === '1' ? 'Yes' : 'No' })
            }
        
        enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.MAILADD1, FieldValue: enrollmentViewModel.MAILADD1 })
        enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.MAILADD2, FieldValue: enrollmentViewModel.MAILADD2 })
        enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.MAILCITY, FieldValue: enrollmentViewModel.MAILCITY })
        enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.MAILST, FieldValue: enrollmentViewModel.MAILST })
        enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.MAILZIP, FieldValue: enrollmentViewModel.MAILZIP })
        enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.LTCFACILITY, FieldValue: enrollmentViewModel.LTCFACILITY })
        enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.LTCPHONE, FieldValue: enrollmentViewModel.LTCPHONE })
        if (enrollmentViewModel.LTCADD1 !== undefined && enrollmentViewModel.LTCADD1 !== '') {
            enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.LTCADD1, FieldValue: enrollmentViewModel.LTCADD1 })
        }

        enrollmentData.EnrollmentFields.push({
            FieldCode: EnrollmentFieldCodeName.MEDA,
            FieldValue:
                enrollmentViewModel.MEDA === undefined || enrollmentViewModel.MEDA === null
                    ? ''
                    : moment(enrollmentViewModel.MEDA).format('MM/DD/YYYY')
        })
        enrollmentData.EnrollmentFields.push({
            FieldCode: EnrollmentFieldCodeName.MEDB,
            FieldValue:
                enrollmentViewModel.MEDB === undefined || enrollmentViewModel.MEDB === null
                    ? ''
                    : moment(enrollmentViewModel.MEDB).format('MM/DD/YYYY')
        })
        enrollmentData.EnrollmentFields.push({
            FieldCode: EnrollmentFieldCodeName.PREMIUMPAYTYPE,
            FieldValue: enrollmentViewModel.PWO === undefined ? '' : enrollmentViewModel.PWO
        }) //to check

        enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.LANG, FieldValue: enrollmentViewModel.LANG })
        //if (!enrollmentViewModel.ISSINGLEGROUP) {
        let eobValue = ''
        // let paperlessValue = ''
        let accessibleValue = ''

        if (enrollmentViewModel.EOB !== undefined && enrollmentViewModel.EOB !== null) {
            /*
            if (enrollmentViewModel.EOB === '3') {
                paperlessValue = 'Yes'
            } else if (enrollmentViewModel.EOB.toString().toUpperCase() === 'N') {
                paperlessValue = 'No'
            }
            
            else */
            if (
                enrollmentViewModel.EOB.toString().toUpperCase() === 'EEOB' ||
                enrollmentViewModel.EOB === '5' ||
                enrollmentViewModel.EOB === '6' ||
                enrollmentViewModel.EOB === '7' ||
                enrollmentViewModel.EOB === '9'
            ) {
                eobValue = 'Yes'
            } else if (
                enrollmentViewModel.EOB.toString().toUpperCase() === 'PEOB' ||
                enrollmentViewModel.EOB === '1' ||
                enrollmentViewModel.EOB === '2' ||
                enrollmentViewModel.EOB === '4' ||
                enrollmentViewModel.EOB === '8'
            ) {
                eobValue = 'No'
            }

            if (enrollmentViewModel.ISSINGLEGROUP) {
                eobValue = ''
            }

            if (enrollmentViewModel.EOB === '1' || enrollmentViewModel.EOB === '5') {
                accessibleValue = 'Large Print'
            } else if (enrollmentViewModel.EOB === '2' || enrollmentViewModel.EOB === '6') {
                accessibleValue = 'Braille'
            } else if (enrollmentViewModel.EOB === '4' || enrollmentViewModel.EOB === '7') {
                accessibleValue = 'Audio CD'
            } else if (enrollmentViewModel.EOB === '8' || enrollmentViewModel.EOB === '9') {
                accessibleValue = 'Data CD'
            } else {
                accessibleValue = ''
            }
        } else {
            enrollmentViewModel.EOB = ''
        }
        /* SSI: Remove 'Receives Electronic Explanation of Benefits' for the External agent and Data Entry enrollment
         Assign the EEOB/PEOB value to  Receives Paperless Documents
         */

        if (insCompanyName !== '' && insCompanyName !== undefined && insCompanyName !== null) {
            if (insCompanyName !== this.portalGlob.insuranceCompanyNameNEJE) {
                //if (!(enrollmentViewModel.AGENTDEX.toUpperCase() === "MAIL" || enrollmentViewModel.AGENTDEX.toUpperCase() === "ICALL"))
                //{
                enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.EOB, FieldValue: eobValue })
                //}
            } else if (enrollmentViewModel.AGENTDEX === 'WEBIN') {
                enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.EOB, FieldValue: eobValue })
            }
        }
        /*
        if ((insCompanyName !== this.portalGlob.insuranceCompanyNameNEJE) &&
            (enrollmentViewModel.AGENTDEX.toUpperCase() === "MAIL" || enrollmentViewModel.AGENTDEX.toUpperCase() === "ICALL")) {
            enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.PaplerlessEOB, FieldValue: eobValue })
        }
        else
            if ((insCompanyName !== this.portalGlob.insuranceCompanyNameNEJE) && !(enrollmentViewModel.AGENTDEX.toUpperCase() === "EENRL"))
            {
                enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.PaplerlessEOB, FieldValue: paperlessValue })
        }
            else
               {
                    enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.PaplerlessEOB, FieldValue: paperlessValue })
            }
        */

        /*
        if (insCompanyName !== this.portalGlob.insuranceCompanyNameNEJE) //SSI
        {
            //if (enrollmentViewModel.AGENTDEX.toUpperCase() === "MAIL" || enrollmentViewModel.AGENTDEX.toUpperCase() === "ICALL")
            //{
            //    enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.PaplerlessEOB, FieldValue: eobValue })
            //}
            //else if (!(enrollmentViewModel.AGENTDEX.toUpperCase() === "EENRL"))
            //{
            enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.PaplerlessEOB, FieldValue: paperlessValue })
            //  }
        }
        */
        //}
        if (
            insCompanyName !== '' &&
            insCompanyName !== undefined &&
            insCompanyName !== null &&
            insCompanyName == this.portalGlob.insuranceCompanyNameNEJE &&
            enrollmentViewModel.PLANYEAR === '2023'
        ) {
            // Accessible not required
            // enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.Accessible, FieldValue: accessibleValue })
        } else {
            enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.Accessible, FieldValue: accessibleValue })
        }
        /*
        else
        {
           enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.PaplerlessEOB, FieldValue: paperlessValue })

        }
        */

        /*

        // Remove 'Receives Electronic Explanation of Benefits' for the External agent and Data Entry enrollment
        // Assign the EEOB/PEOB value to  Receives Paperless Documents

        bool removeEOB = false;
        string eobValue = "";

        foreach(EnrollmentFieldCode item in enrollment.EnrollmentFields)
        {

            if (!removeEOB) {
                removeEOB = (item.FieldCode == "Enrollment Type" && (item.FieldValue.ToUpper() == "MAIL" || item.FieldValue.ToUpper() == "ICALL"));
            }
            if (removeEOB && (item.FieldCode == "Receives Electronic Explanation of Benefits")) {
                eobValue = item.FieldValue;
            }
            if (removeEOB && (item.FieldCode == "Receives Paperless Documents")) {
                item.FieldValue = eobValue;
            }
        }
        */

        if (insCompanyName !== '' && insCompanyName !== undefined && insCompanyName !== null) {
            if (insCompanyName == this.portalGlob.insuranceCompanyNameNEJE && enrollmentViewModel.PLANYEAR === '2021') {
                enrollmentData.EnrollmentFields.push({
                    FieldCode: EnrollmentFieldCodeName.ENROLLEEWORKSTATUS,
                    FieldValue: enrollmentViewModel.ENROLLEEWORKSTATUS
                })
                enrollmentData.EnrollmentFields.push({
                    FieldCode: EnrollmentFieldCodeName.SPOUSEWORKSTATUS,
                    FieldValue: enrollmentViewModel.SPOUSEWORKSTATUS
                })
            }
        }

        //}

        if (enrollmentViewModel.ISSTCOB !== undefined) {
            if (!enrollmentViewModel.ISSTCOB) {
                enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.PCARRIER, FieldValue: enrollmentViewModel.CARRIER })
                enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.PACCOUNT, FieldValue: enrollmentViewModel.ACCOUNT })
                enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.PGROUP, FieldValue: enrollmentViewModel.GROUP })
            } else {
                enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.SCARRIER, FieldValue: enrollmentViewModel.CARRIER })
                enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.SACCOUNT, FieldValue: enrollmentViewModel.ACCOUNT })
                enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.SGROUP, FieldValue: enrollmentViewModel.GROUP })
                enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.SECMBRID, FieldValue: enrollmentViewModel.SECMBRID })

                var relcd = enrollmentViewModel.RELCD === undefined || enrollmentViewModel.RELCD === null ? '' : enrollmentViewModel.RELCD
                if (relcd != '') {
                    enrollmentData.EnrollmentFields.push({
                        FieldCode: EnrollmentFieldCodeName.RELCD,
                        FieldValue: enrollmentViewModel.RELCD + '-' + enrollmentViewModel.RELTEXT
                    })
                }
                enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.FAMILYID, FieldValue: enrollmentViewModel.FAMILYID })

                var personcd = enrollmentViewModel.PERSONCD === undefined || enrollmentViewModel.PERSONCD === null ? '' : enrollmentViewModel.PERSONCD
                if (personcd != '') {
                    enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.PERSONCD, FieldValue: enrollmentViewModel.PERSONCD })
                }
            }
        }
        enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.CAREQUALIFIER, FieldValue: enrollmentViewModel.CAREQUAL }) //to check
        enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.CAREFACILITY, FieldValue: enrollmentViewModel.CAREFAC }) //to check
        enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.EXTERNALMEMBERID, FieldValue: enrollmentViewModel.EXTERNALID }) //to check
        enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.OTHERCOVNAME, FieldValue: enrollmentViewModel.OTHCVRGNAME })
        enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.OTHCVRGID, FieldValue: enrollmentViewModel.OTHCVRGID })
        enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.OTHERCOVGRP, FieldValue: enrollmentViewModel.OTHCVRGGRP })
        enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.OTHERCOVRXBIN, FieldValue: enrollmentViewModel.COBBIN })
        enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.OTHERCOVRXPCN, FieldValue: enrollmentViewModel.COBPCN })
        enrollmentData.EnrollmentFields.push({
            FieldCode: EnrollmentFieldCodeName.OTHERCOVEF,
            FieldValue:
                enrollmentViewModel.COBEFFDT === undefined || enrollmentViewModel.COBEFFDT === null
                    ? ''
                    : moment(enrollmentViewModel.COBEFFDT).format('MM/DD/YYYY')
        })
        enrollmentData.EnrollmentFields.push({
            FieldCode: EnrollmentFieldCodeName.OTHERCOVTR,
            FieldValue:
                enrollmentViewModel.COBTERMDT === undefined || enrollmentViewModel.COBTERMDT === null
                    ? ''
                    : moment(enrollmentViewModel.COBTERMDT).format('MM/DD/YYYY')
        })

        enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.AUTHREPNAME, FieldValue: enrollmentViewModel.AUTHREPNAME })
        enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.AUTHREPPHONE, FieldValue: enrollmentViewModel.AUTHREPPHONE })
        enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.AUTHREPREL, FieldValue: enrollmentViewModel.AUTHREPREL })
        enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.AUTHREPADD1, FieldValue: enrollmentViewModel.AUTHREPADD1 })
        enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.AUTHREPADD2, FieldValue: enrollmentViewModel.AUTHREPADD2 })
        enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.AUTHREPCITY, FieldValue: enrollmentViewModel.AUTHREPCITY })
        enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.AUTHREPST, FieldValue: enrollmentViewModel.AUTHREPST })
        enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.AUTHREPZIP, FieldValue: enrollmentViewModel.AUTHREPZIP })

        if (Number(enrollmentViewModel.PLANYEAR) > this.portalGlob.Planyear2024) {
            // enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.INDREPIND, FieldValue: enrollmentViewModel.INDREPIND })
            enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.INDREPNAME, FieldValue: enrollmentViewModel.INDREPNAME })
            enrollmentData.EnrollmentFields.push({
                FieldCode: EnrollmentFieldCodeName.RELTOENROLL,
                FieldValue: enrollmentViewModel.displayRELTOENROLL
            })
            enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.NPN, FieldValue: enrollmentViewModel.NPN })
        }

        enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.ACCHOLDERNAME, FieldValue: enrollmentViewModel.ACCHOLDERNAME })
        enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.ACCOUNTTYPE, FieldValue: enrollmentViewModel.EFTTYPE || '' })
        enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.ROUTINGNB, FieldValue: enrollmentViewModel.ROUTINGNB })
        enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.FININSTNAME, FieldValue: enrollmentViewModel.FININSTNAME })
        enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.ACCOUNTNB, FieldValue: enrollmentViewModel.ACCOUNTNB })
        enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.NOTES, FieldValue: enrollmentViewModel.NOTES })

        enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.DISENROLLIND, FieldValue: enrollmentViewModel.DISENROLLIND })
        enrollmentData.EnrollmentFields.push({
            FieldCode: EnrollmentFieldCodeName.DISENROLLDATE,
            FieldValue:
                enrollmentViewModel.DISENROLLDATE === undefined ||
                enrollmentViewModel.DISENROLLDATE === null ||
                enrollmentViewModel.DISENROLLDATE === ''
                    ? ''
                    : moment(enrollmentViewModel.DISENROLLDATE).format('MM/DD/YYYY')
        })
        enrollmentData.EnrollmentFields.push({
            FieldCode: EnrollmentFieldCodeName.DISENROLLNOTICEDT,
            FieldValue:
                enrollmentViewModel.DISENROLLNOTICEDT === undefined ||
                enrollmentViewModel.DISENROLLNOTICEDT === null ||
                enrollmentViewModel.DISENROLLNOTICEDT === ''
                    ? ''
                    : moment(enrollmentViewModel.DISENROLLNOTICEDT).format('MM/DD/YYYY')
        })
        enrollmentData.EnrollmentFields.push({
            FieldCode: EnrollmentFieldCodeName.DISENROLLREASONCD,
            FieldValue: enrollmentViewModel.DISENROLLREASONCD
        })
        enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.DISENROLLTYPE, FieldValue: enrollmentViewModel.DISENROLLTYPE })

        if (Number(enrollmentViewModel.PLANYEAR) < this.portalGlob.Planyear2026) {
            enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.ETHNICITY, FieldValue: enrollmentViewModel.displayEthnicity })
            enrollmentData.EnrollmentFields.push({ FieldCode: EnrollmentFieldCodeName.RACE, FieldValue: enrollmentViewModel.displayRace })
        }

        const effdt = moment(enrollmentViewModel.EFFDT, 'MM/D/YYYY', true);
        const endDate = moment(this.portalGlob.EnrollmentGenderEndDate, 'MM/DD/YYYY', true);


        if ((Number(enrollmentViewModel.PLANYEAR) > this.portalGlob.Planyear2024)
            && (effdt.isBefore(endDate))) {
            enrollmentData.EnrollmentFields.push({
                FieldCode: EnrollmentFieldCodeName.CURRENTGENDER,
                FieldValue: enrollmentViewModel.displayCurrentGender
            })
            enrollmentData.EnrollmentFields.push({
                FieldCode: EnrollmentFieldCodeName.CURRENTGENDEROTH,
                FieldValue: enrollmentViewModel.CURRENTGENDEROTH
            })
            enrollmentData.EnrollmentFields.push({
                FieldCode: EnrollmentFieldCodeName.GENDERNPRONOUN,
                FieldValue: enrollmentViewModel.displayGenderProNoun
            })
            enrollmentData.EnrollmentFields.push({
                FieldCode: EnrollmentFieldCodeName.GENDERNPRONOUNOTH,
                FieldValue: enrollmentViewModel.GENDERNPRONOUNOTH
            })
        }
        
        return enrollmentData
    }
}
